
import Http from '@/utils/axios'
import Device from './device'
import { getQueryValue, deleteUrlParam, clearUrlCodeAndReloadPage} from "@/utils";
import tools from './tools' //弹框

export function getWxCode(type) {
  if(Device.isWeixin) {
    let code = getQueryValue("code");
    let state = getQueryValue("state");
    let specWxtoken = getQueryValue("specWxtoken");
    let url = window.location.href;
    if(code) {
      url = deleteUrlParam(url,['code'])
    }
    if(state) {
      url = deleteUrlParam(url,["state"]);
    }
    if (specWxtoken) {
      url = deleteUrlParam(url, ["specWxtoken"]);
    }
    console.log(url,'----url----')
    Http.post("/api/account/wx/config", {}).then(
      res => {
        if (res.errorCode === 0) {
          let redirectUri = window.encodeURIComponent(url);
          let snsapiUserinfo = type === 2 ? "snsapi_base" : "snsapi_userinfo";
          if (res.results.appId) {
            let wechatUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
              res.results.appId
            }&redirect_uri=${redirectUri}&response_type=code&scope=${res.results
              .scope || snsapiUserinfo}&state=STATE#wechat_redirect`;
            window.location.href = wechatUrl;
          } else {
            tools.showToast(res.errorStr, 2000);
            console.log(res)
          }
        }
      },
      (error) => {
        console.log(error,'获取code失败')
      }
    );
  // } else {
    // tools.showToast("请在微信环境中访问", 2000);
  }
}

// 
let codeLockNum = 0 

export function bindWechat(){
  if(Device.isWeixin) { 
    let code = getQueryValue("code");
    // console.log(code,'code')
    // 最多允许循环 3 次
    if (code && codeLockNum < 3) {
      codeLockNum++;
      Http.post("/api/account/wx/bind", {
        code: code
      }).then(
        res => {
          if (res.errorCode === 0) {
            tools.showToast("绑定成功！", 2000);
            // callback && callback();
            clearUrlCodeAndReloadPage();
          } else {
            tools.showToast(res.errorStr, 2000);
          }
        },
        err => {
          console.log(err, "微信绑定失败");
        }
      );
    }
    // } else {
    // tools.showToast("请在微信环境中访问", 2000);
  }
}

// 注册wxjssdk
export function registerwxsdk(config) {
  return new Promise((resolve, reject) => {
    if (typeof wx !== 'undefined') {
      resolve()
    } else {
      const { appId, timestamp, noncestr, signature } = config
      const d = {
        debug: false,
        appId, // 必填，公众号的唯一标识
        timestamp, // 必填，生成签名的时间戳
        nonceStr: noncestr, // 必填，生成签名的随机串
        signature, // 必填，签名，见附录1
        jsApiList: ['getLocation'], // 需要使用的API列表 见附录2
      }
      wx.config(d)
      wx.ready(function () {
        console.log('wx.config===ready');
        resolve()
      })
      wx.error(function (res) {
        console.error(res,'微信jssdk注册失败' );
        reject()
      })
    }
  })
}

// 获取wxjssdk 信息
export function getwxsdkInfo() {
  return new Promise((resolve, reject) => {
    Http.post('/api/wx/getWxConfigInfo', {
      url: location.origin
    }).then(res => {
      if (res.errorCode) {
        reject('获取失败')
        return
      }
      resolve(res.results)
    }, () => {
      reject('获取失败')
    })
  })
}
